import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aebcacaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rounded-lg shadow-lg bg-white overflow-hidden whitespace-nowrap border border-gray-200 flex flex-col space-y-2 py-3 px-1" }
const _hoisted_2 = { class: "relative bg-white" }
const _hoisted_3 = { class: "relative bg-white" }
const _hoisted_4 = { class: "relative bg-white" }
const _hoisted_5 = { class: "relative bg-white" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider border-t" }, null, -1))
const _hoisted_7 = { class: "relative bg-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!

  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition ease-out duration-200",
    "enter-from-class": "opacity-0 translate-y-1",
    "enter-to-class": "opacity-100 translate-y-0",
    "leave-active-class": "transition ease-in duration-150",
    "leave-from-class": "opacity-100 translate-y-0",
    "leave-to-class": "opacity-0 translate-y-1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_PopoverPanel, { class: "absolute z-10 left-0 top-full transform -mt-1 w-screen sm:w-auto sm:pr-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: "/docs/client",
                class: "block px-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Client")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: "/docs/hero",
                class: "block px-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Hero")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/docs/datastore",
                class: "block px-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Datastore")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/docs/cloud",
                class: "block px-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cloud")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(),
            _hoisted_6,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: "/docs/sql",
                class: "block px-5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ulixee SQL Spec")
                ]),
                _: 1
              })
            ]),
            _createTextVNode()
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}